export var Methods;
(function (Methods) {
    Methods["LIGHT"] = "LIGHT";
    Methods["DARK"] = "DARK";
    Methods["TOGGLE"] = "TOGGLE";
    Methods["SET_STORAGE"] = "SET_STORAGE";
    Methods["DESTROY"] = "DESTROY";
})(Methods || (Methods = {}));
